// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"2b0479f4","422":"451029b3","488":"ed44a62a","662":"d38a0331","817":"18ba9287","878":"117e842c","930":"c735fe27"}[chunkId] + ".chunk.js";
};